import moment from 'moment';

export const getDefaultTimesByDay = (date, resourceTimeSlots) => {
  const dayOfWeek = moment(date).isoWeekday();

  const matching = resourceTimeSlots?.find(
    (slot) => slot.DayOfWeek === dayOfWeek,
  );

  if (!matching) return null;

  const fromTime = moment.utc(matching.FromTime);
  const toTime = moment.utc(matching.ToTime);

  const baseDate = moment(date).startOf('day');

  const opens = baseDate
    .clone()
    .hour(fromTime.hour())
    .minute(fromTime.minute())
    .second(0);
  const closes = baseDate
    .clone()
    .hour(toTime.hour())
    .minute(toTime.minute())
    .second(0);

  return {
    startHour: fromTime.hour(),
    startMin: fromTime.minute(),
    endHour: toTime.hour(),
    endMin: toTime.minute(),
    opens: opens.toDate(),
    closes: closes.toDate(),
  };
};

export const sortBookingDates = (bookings) => {
  return [...bookings].sort(
    (a, b) => moment(a.FromTime).valueOf() - moment(b.FromTime).valueOf(),
  );
};
